import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { Branch } from '@app/_models/master/branch';

@Injectable({
  providedIn: 'root'
})
export class BranchService {
  
  constructor(private http: HttpClient) { }

  /**
   * Get all branches
   */
  getAll(): Observable<Branch[]> {
    return this.http.get<Branch[]>(`${environment.apiUrl}/Branches`);
  }

  /**
   * Get branches by company ID
   */
  getByCompanyId(companyId: string): Observable<Branch[]> {
    return this.http.get<Branch[]>(`${environment.apiUrl}/Branches?companyId=${companyId}`);
  }

  /**
   * Get branch by ID
   */
  getById(id: string): Observable<Branch> {
    return this.http.get<Branch>(`${environment.apiUrl}/Branches/${id}`);
  }

  /**
   * Add new branch
   */
  add(branch: Branch): Observable<Branch> {
    return this.http.post<Branch>(`${environment.apiUrl}/Branches`, branch);
  }

  /**
   * Update existing branch
   */
  update(id: string, branch: Branch): Observable<Branch> {
    return this.http.put<Branch>(`${environment.apiUrl}/Branches/${id}`, branch);
  }

  /**
   * Delete branch
   */
  delete(id: string): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/Branches/${id}`);
  }

  /**
   * Get user accessible branches
   */
  getUserAccessibleBranches(userId: number): Observable<Branch[]> {
    return this.http.get<Branch[]>(`${environment.apiUrl}/Branches/user/${userId}/accessible`);
  }
}
